import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { JwtModule } from '@auth0/angular-jwt';
import { getStoredToken } from 'app/state/auth.repository';
import { AppComponent } from './app.component';
import { environment } from 'environments/environment';
import { UnauthorizedModule } from './modules/unauthorized/unauthorized.module';
import { SessionInterceptor } from './modules/core/interceptors/session.interceptor';
import { DateInterceptor } from './modules/core/interceptors/date.interceptor';
import { ImageInterceptor } from './modules/core/interceptors/image.interceptor';
import { BaseUrlInterceptor } from './modules/core/interceptors/base-url.interceptor';
import { CoreModule } from './modules/core/core.module';

import { RetryInterceptor } from './modules/core/interceptors/retry.interceptor';
import { EnvState } from './modules/shared/helpers/env-state';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoRootModule } from './transloco-root.module';
import { BlobStorageService } from './shared/azure-blob//blob-storage.service';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AppRoutingModule } from './app-routing.module';
import { BaseModule } from './modules/base/base.module';
import { SharedModule } from './modules/shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgxEchartsModule } from 'ngx-echarts';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerInterceptor } from './modules/core/interceptors/spinner.interceptor';

const optionalModules = [];
const optionalProviders = [];

optionalModules.push(UnauthorizedModule);

if (environment.features.offlineChanges) {
  optionalProviders.push({
    provide: HTTP_INTERCEPTORS,
    useClass: RetryInterceptor,
    multi: true,
  });
}
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import PrimeNgCustomPreset from './styles/primeng-custom-preset';
import { MiniProfilerInterceptor } from './shared/profiler-interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import localeEn from '@angular/common/locales/en';
import { CustomGptComponent } from './modules/chatGpt/custom-gpt.component';
import { SimpleChatComponent } from './modules/chatGpt/chat/simple-chat.component';
import { FormsModule } from '@angular/forms';

registerLocaleData(localeDa);
registerLocaleData(localeEn);
//initializeApp(environment.firebase);

@NgModule({
  declarations: [AppComponent, CustomGptComponent, SimpleChatComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    SharedModule,
    ToastModule,
    BrowserModule,
    CommonModule,
    // GooglePlaceModule,
    NoopAnimationsModule,
    TranslocoRootModule,
    MatDialogModule,
    CoreModule,
    BaseModule,
    AppRoutingModule,
    ProgressSpinnerModule,
    PopoverModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    // AgmCoreModule.forRoot({
    //   apiKey: 'AIzaSyDOzV5scbP1PWye-hm6iiqyufG8p1-7Ew4',
    // }),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => getStoredToken(),
        allowedDomains: [window.location.origin],
      },
    }),
    // Dev builds have no valid ngsw.json, so an enabled service worker caches
    // whatever it first saw and then fails every update with hash mismatches
    // (VERSION_INSTALLATION_FAILED) — silently serving stale JS on ng serve.
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    ...optionalModules,
  ],
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: PrimeNgCustomPreset,
        options: { darkModeSelector: false },
      },
    }),
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DateInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ImageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseUrlInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    {
      provide: EnvState,
      useValue: environment,
    },
    BlobStorageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MiniProfilerInterceptor,
      multi: true,
    },
    ...optionalProviders,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
